import React from 'react';
import { Star, TrendingUp, Minus, TrendingDown, AlertTriangle } from 'lucide-react';

export type KhdaRating = 'Outstanding' | 'Very Good' | 'Good' | 'Acceptable' | 'Weak' | 'Very Weak' | 'Not yet inspected';

interface KhdaBadgeProps {
  rating: KhdaRating;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

const ratingConfig: Record<KhdaRating, { bg: string; text: string; border: string; icon: React.ReactNode; dot: string }> = {
  Outstanding: {
    bg: 'bg-purple-100', text: 'text-purple-900', border: 'border-purple-400',
    icon: <Star size={11} className="fill-purple-800 text-purple-800" />, dot: 'bg-purple-800',
  },
  'Very Good': {
    bg: 'bg-green-100', text: 'text-green-900', border: 'border-green-400',
    icon: <TrendingUp size={11} className="text-green-800" />, dot: 'bg-green-800',
  },
  Good: {
    bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-400',
    icon: <TrendingUp size={11} className="text-orange-700" />, dot: 'bg-orange-600',
  },
  Acceptable: {
    bg: 'bg-sky-100', text: 'text-sky-800', border: 'border-sky-400',
    icon: <Minus size={11} className="text-sky-700" />, dot: 'bg-sky-600',
  },
  Weak: {
    bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-300',
    icon: <TrendingDown size={11} className="text-orange-700" />, dot: 'bg-orange-700',
  },
  'Very Weak': {
    bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-300',
    icon: <AlertTriangle size={11} className="text-red-700" />, dot: 'bg-red-700',
  },
  'Not yet inspected': {
    bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300',
    icon: <Minus size={11} className="text-gray-600" />, dot: 'bg-gray-500',
  },
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs gap-1',
  md: 'px-2.5 py-1 text-xs gap-1.5',
  lg: 'px-3 py-1.5 text-sm gap-1.5',
};

export default function KhdaBadge({ rating, size = 'md', showIcon = true }: KhdaBadgeProps) {
  const config = ratingConfig[rating];
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${config.bg} ${config.text} ${config.border} ${sizeClasses[size]}`}
    >
      {showIcon && config.icon}
      KHDA: {rating}
    </span>
  );
}